import { getLayout } from "@components/common/Layout";
import Range from "@components/Range";
import { setFilterList, setPrice } from "@store/reducers/search";
import { Button } from "components";
import gate from "gate";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { commafy } from "src/utils";

import { list_status, types } from "../DesktopTab";
import Details from "./Details";

type ItemProps = {
  list: any[];
  data?: any;
  keyItem: string;
};

function isItemInArray(item: any, array: any[], type?: string) {
  return type == "courseCategoryIds"
    ? array?.some((i: any) => i.id === item.id && i.type === item.type)
    : array?.some((i: any) => i === item);
}

const RenderItems = ({ list, keyItem, data }: ItemProps) => {
  const dispatch = useDispatch();
  return (
    <>
      {list?.map(({ id, name, type }, index) => (
        <li key={JSON.stringify(index)} className="flex items-center">
          <label className="flex items-center rounded-none focus-within:outline-0">
            <input
              type="checkbox"
              defaultChecked={
                keyItem !== "courseCategoryIds"
                  ? isItemInArray(id, data)
                  : isItemInArray({ id, type }, data, "courseCategoryIds")
              }
              onChange={(e: any) =>
                dispatch(
                  setFilterList({
                    checked: e.target.checked,
                    value: { id, type },
                    key: keyItem,
                  })
                )
              }
              className="peer ml-[10px] h-[18px] min-w-[18px] rounded-none accent-blue-550 focus-within:outline-0 active:bg-blue-550"
            />{" "}
            <span className="peer-checked:text-blue-550">{name}</span>
          </label>
        </li>
      ))}
    </>
  );
};

const Filter = () => {
  const state = useSelector((state: any) => state.search);
  const { register } = useForm();
  const { data, isSuccess } = useQuery(
    "filter-tab-data",
    () => gate.searchInput(),
    {
      select: (data: any) => data?.data?.output,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );
  const dispatch = useDispatch();
  const router = useRouter();
  const handleApplyFilters = () => {
    router.push("/search");
  };
  // makeStore().persistor();
  return (
    <>
      <div className="h-full min-h-[50vh] w-full bg-[#FAFAFC] text-black-450">
        <div className="flex h-[52px] items-center justify-between bg-white px-10 py-4 shadow-md">
          <span>فیلتر ها</span>
          <Link href={"/search"}>
            <span className="rotate-45 cursor-pointer text-xl">+</span>
          </Link>
        </div>
        <div className="mt-6 w-full bg-white px-10 shadow-md">
          <Details title="نوع">
            <ul className="space-y-[10px]">
              <RenderItems
                data={state.entityType}
                list={types}
                keyItem="entityType"
              />
            </ul>
          </Details>
          <Details title="وضعیت">
            <ul className="w-full space-y-2">
              <RenderItems
                keyItem="courseType"
                data={state.courseType}
                list={list_status}
              />
            </ul>
          </Details>
          <Details title="موضوع">
            <ul className="w-full space-y-2">
              <RenderItems
                data={state.courseCategoryIds}
                keyItem="courseCategoryIds"
                list={data?.courseCategories}
              />
            </ul>
          </Details>
          <Details title="قیمت">
            <ul
              className="relative flex flex-col py-5 md:p-5"
              onClick={(e) => e.preventDefault()}
            >
              <div className="mb-5 flex">
                از
                <span className="mx-1">{commafy(data?.minPrice)}</span>
                تا
                <span className="mx-1">{commafy(data?.maxPrice)}</span>
                <span>تومان</span>
              </div>
              {data && (
                <Range
                  min={data?.minPrice}
                  max={data?.maxPrice}
                  onChange={({ min, max }: any) =>
                    dispatch(setPrice({ min, max }))
                  }
                />
              )}
            </ul>
          </Details>
          <Details title="استاد">
            <ul className="w-full space-y-2">
              <RenderItems
                data={state.teacherIds}
                keyItem="teacherIds"
                list={data?.teachers}
              />
            </ul>
          </Details>
          <Details detailsClass="!border-none" title="مدرک">
            <ul className="w-full space-y-2">
              <RenderItems
                data={state.certificateIds}
                keyItem="certificateIds"
                list={data?.courseCertificate}
              />
            </ul>
          </Details>
        </div>
        <div className="mt-4 mb-5 flex h-[52px] items-center bg-white px-10 py-4 shadow-md">
          <Button
            CClassName="text-xs bg-blue text-white w-full py-2"
            onClick={handleApplyFilters}
          >
            اعمال فیلتر
          </Button>
        </div>
      </div>
    </>
  );
};
Filter.getLayout = (page: any) => getLayout(page, { footer: true });

export default Filter;
